import { render, staticRenderFns } from "./SetTag.vue?vue&type=template&id=0b9b219b&scoped=true&"
import script from "./SetTag.vue?vue&type=script&lang=js&"
export * from "./SetTag.vue?vue&type=script&lang=js&"
import style0 from "./SetTag.vue?vue&type=style&index=0&id=0b9b219b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9b219b",
  null
  
)

export default component.exports